import { klickartPerformaticTimer } from 'src/performant/timer'

window.addEventListener('load', klickartPerformaticTimer)
